export default __webpack_public_path__ + "static/media/icon-info.20f42b93.svg";